// ==========================
// URLs Resource
// Contains the URLs to specific API endpoints.
// ==========================

import { apiBaseUrl } from '@shared/configs';
import {
  appApiKey,
  appName,
  envBaseUrl,
  getDefaultPaginationOffset,
  getDischargeValidateDaysLimit,
  getGeneticReportsDaysLimit,
  getGeneticReportsDelayDays,
  getGeneticReportsEffectDate,
  getGeneticReportsEndDate,
  getGeneticReportsStartDate,
  getHealthRecordsScreeningDaysLimit,
  getHealthScreeningDaysLimit,
  getHistoCytoDaysLimit,
  getHistoCytoDelayDays,
  getHistoCytoEffectDate,
  getHistoCytoEndDate,
  getHistoCytoPaginationOffset,
  getHistoCytoStartDate,
  getIQuitSmokingUrl,
  getLabResultsDaysLimit,
  getNehrAccessHistoryPaginationOffset,
  getPrescriptionValidateDaysLimit,
  getPSSQuestionUrl,
  getPublicFAQUrl,
  getRadioLogyDaysLimit,
  getRadiologyDelayDays,
  getRadiologyEffectDate,
  getRadiologyEndDate,
  getRadiologyPaginationOffset,
  getRadiologyStartDate,
  getValidateDaysLimit,
  getValidateNehrAccessHistoryDaysLimit,
  sitecoreHomeBaseUrl,
} from '@shared/configs/configs/config';

// App name
export const APP_NAME = appName();

// Base URL for APIs
const API_BASE_URL = apiBaseUrl();

// Base url for Env
export const ENV_BASE_URL = envBaseUrl();

export const API_KEY = appApiKey();

export const PUBLIC_FAQ_URL = getPublicFAQUrl();

export const VALIDATE_DAYS_LIMIT = getValidateDaysLimit();

export const LAB_RESULTS_DAYS_LIMIT = getLabResultsDaysLimit();

export const HISTO_CYTO_DAYS_LIMIT = getHistoCytoDaysLimit();

export const HISTO_CYTO_START_DATE = getHistoCytoStartDate();

export const HISTO_CYTO_DELAY_DAYS = getHistoCytoDelayDays();

export const HISTO_CYTO_END_DATE = getHistoCytoEndDate();

export const HISTO_CYTO_OFFSET_LIMIT = getHistoCytoPaginationOffset();

export const HISTO_CYTO_EFFECT_DATE = getHistoCytoEffectDate();

export const RADIOLOGY_DAYS_LIMIT = getRadioLogyDaysLimit();

export const RADIOLOGY_DELAY_START_DATE = getRadiologyStartDate();

export const RADIOLOGY_DELAY_END_DATE = getRadiologyEndDate();

export const RADIOLOGY_DELAY_DAYS = getRadiologyDelayDays();

export const RADIOLOGY_EFFECT_DATE = getRadiologyEffectDate();

export const HEALTH_SCREENING_DAYS_LIMIT = getHealthScreeningDaysLimit();

// Adding GENETIC_REPORTS exports
export const GENETIC_REPORTS_DAYS_LIMIT = getGeneticReportsDaysLimit();

export const GENETIC_REPORTS_START_DATE = getGeneticReportsStartDate();

export const GENETIC_REPORTS_END_DATE = getGeneticReportsEndDate();

export const GENETIC_REPORTS_DELAY_DAYS = getGeneticReportsDelayDays();

export const GENETIC_REPORTS_EFFECT_DATE = getGeneticReportsEffectDate();

export const HEALTHRECORDS_SCREENING_DAYS_LIMIT = getHealthRecordsScreeningDaysLimit();

export const DISCHARGE_DAYS_LIMIT = getDischargeValidateDaysLimit();

export const NEHR_ACCESS_HISTORY_DATE_RANGE_DAYS_LIMIT = getValidateNehrAccessHistoryDaysLimit();

export const PRESCRIPTION_DAYS_LIMIT = getPrescriptionValidateDaysLimit();

export const RADIOLOGY_OFFSET_LIMIT = getRadiologyPaginationOffset();

export const NEHR_ACCESS_HISTORY_OFFSET_LIMIT = getNehrAccessHistoryPaginationOffset();

export const DEFAULT_PAGINATION_OFFSET = getDefaultPaginationOffset();

export const PSS_QUESTION_URL = getPSSQuestionUrl();

export const IQUIT_SMOKING_URL = getIQuitSmokingUrl();

// ==========================
// Common
// ==========================
export const GET_TRANSLATIONS_URL = `${API_BASE_URL}/v1/public/commons/translations`;
export const GET_PUBLIC_SYSTEM_SETTINGS_URL = `${API_BASE_URL}/v1/public/commons/systemconfigs`;
export const GET_PUBLIC_RECAPTCHA = `${API_BASE_URL}/v1/public/commons/validatecaptcha`;

// Profile Eligibility
export const GET_PROFILE_ELIGIBILITY_HEALTHPLAN = `${API_BASE_URL}/v1/commons/profileeligibility/healthplan`;
export const GET_PROFILE_ELIGIBILITY_NGEMR_PATIENT = `${API_BASE_URL}/v1/commons/profileeligibility/ngemrpatient`;
export const GET_PROFILE_ELIGIBILITY_ALIVE = `${API_BASE_URL}/v1/commons/profileeligibility/alive`;

export const GET_CMIS_URL = `${API_BASE_URL}/v1/healthrecords/cmissummary`;
export const GET_CMIS_PDF_URL = `${API_BASE_URL}/v1/healthrecords/cmispdf`;

// Healthier SG URLS
export const GET_HSG_PATIENTINFO_URL = `${API_BASE_URL}/v1/hsg/patient`;
export const GET_HSG_CLINICS_URL = `${API_BASE_URL}/v1/hsg/clinic/searchpcp`;
export const GET_HSG_CHANGEELIGIBILITY_URL = `${API_BASE_URL}/v1/hsg/enrollment/changeeligibility`;
export const GET_HSG_RECOMMENDEDPCP_URL = `${API_BASE_URL}/v1/hsg/clinic/recommendedpcp`;
export const GET_HSG_CARERECIPIENT_URL = `${API_BASE_URL}/v1/hsg/carerecipient`;
export const GET_HSG_H365_URL = `${API_BASE_URL}/v1/hsg/h365/onboarding`;
export const GET_HSG_SFLLETTER_URL = `${API_BASE_URL}/v1/healthassessment/sfl`;
export const GET_HSG_TOU_URL = `${API_BASE_URL}/v1/hsg/program`;
export const GET_HSG_SAVE_ENROLLMENT_URL = `${API_BASE_URL}/v1/hsg/createenrollment`;
export const GET_HSG_SPLASH_ENABLED_URL = `${API_BASE_URL}/v1/hsg/splash`;
export const GET_PATIENT_STATUS = `${API_BASE_URL}/v1/hsg/patient/status`;
export const GET_RECOMMENDED_ARTICLE_URL = `${API_BASE_URL}/v1/hsg/article/recommended`;
export const GET_ARTICLES_URL = `${API_BASE_URL}/v1/hsg/article/list`;
export const GET_BASIC_HEALTH_URL = `${API_BASE_URL}/v1/hsg/healthsummary/details`;
export const GET_SAVE_BASIC_HEALTH_URL = `${API_BASE_URL}/v1/hsg/healthsummary/save`;
export const UPDATE_HEALTH_PLAN_VIEW_STATUS_URL = `${API_BASE_URL}/v1/hsg/healthplan/viewed`;
export const GET_HEALTHPLAN_HISTORY_URL = `${API_BASE_URL}/v1/hsg/healthplan/history`;
export const GET_HEALTHPLAN_DETAILS_URL = `${API_BASE_URL}/v1/hsg/healthplan`;
export const UPDATE_HEALTH_PLAN_POINTS_URL = `${API_BASE_URL}/v1/hsg/healthplan/updatepoints`;
export const GET_EXERCISE_PLAN_URL = `${API_BASE_URL}/v1/hsg/kaki/exerciseplan`;
export const GET_STREAMING_PROGRESS_URL = `${API_BASE_URL}/v1/hsg/kaki/planprogression/details`;
export const UPDATE_STREAMING_PROGRESS_URL = `${API_BASE_URL}/v1/hsg/kaki/planprogression/save`;
export const GET_FEEDBACK_URL = `${API_BASE_URL}/v1/hsg/kaki/feedback`;
export const GET_SCREENING_RECOMMENDED_URL = `${API_BASE_URL}/v1/hsg/screening/recommended`;
export const GET_SCREENING_LATEST_URL = `${API_BASE_URL}/v1/hsg/screening/latest`;
export const GET_HSG_HEALTHPLAN_DASHBOARD_URL = `${API_BASE_URL}/v1/hsg/dashboard`;
export const DISMISS_ACTION_GET_LIST_URL = `${API_BASE_URL}/v1/hsg/dismissaction/list`;
export const UPDATE_DISMISSED_ACTIONS_URL = `${API_BASE_URL}/v1/hsg/dismissaction/save`;
export const DISMISS_ACTION_DELETE_URL = `${API_BASE_URL}/v1/hsg/dismissaction/delete`;
export const GET_HSG_WHATS_NEW_STATUS_URL = `${API_BASE_URL}/v1/hsg/whatsnewsplash`;
export const UPDATE_HSG_WHATS_NEW_STATUS_URL = `${API_BASE_URL}/v1/hsg/whatsnewsplash/save`;
export const GET_RECOMMENDED_VACCINATION_URL = `${API_BASE_URL}/v1/hsg/vaccination/recommended`;
export const SAVE_SMOKING_CESSATION_HISTORY_URL = `${API_BASE_URL}/v1/hsg/smokingcessation/qns/save`;
export const GET_SMOKING_CESSATION_HISTORY_URL = `${API_BASE_URL}/v1/hsg/smokingcessation/qns/get`;
export const GET_SMOKING_CESSATION_CALCULATOR_INFO_URL = `${API_BASE_URL}/v1/hsg/smokingcessation/support`;
export const GET_MINI_ARTICLES = `${API_BASE_URL}/v1/hsg/miniarticle`;
export const GET_CHAS_ELIGIBILITY = `${API_BASE_URL}/v1/hsg/chaseligibility`;
export const GET_SFL_ELIGIBILITY_URL = `${API_BASE_URL}/v1/hsg/sfleligibility`;

// AUTOPAY
export const GET_AUTOPAY_INSTITUTIONS_URL = `${API_BASE_URL}/v1/autopay/institutions`;
export const GET_AUTOPAY_CARD_INSTITUTIONS_URL = `${API_BASE_URL}/v1/autopay/card/institutions`;
export const GET_AUTOPAY_PATIENTS_URL = `${API_BASE_URL}/v1/autopay/patients`;
export const GET_AUTOPAY_CARDS_URL = `${API_BASE_URL}/v1/autopay/cards`;

export const GET_MPGSSESSION_URL = `${API_BASE_URL}/v1/autopay/mpgs/session`;
export const GET_RETRIEVE_MPGSTOKEN_URL = `${API_BASE_URL}/v1/autopay/mpgs/token`;
export const SUBMIT_AUTOPAY_PATIENT_VALIDATE_URL = `${API_BASE_URL}/v1/autopay/patient/validate`;
export const SUBMIT_AUTOPAY_PATIENT_SETUP_URL = `${API_BASE_URL}/v1/autopay/patient/setup`;
export const GET_AUTOPAY_PATIENT_INFO_URL = `${API_BASE_URL}/v1/autopay/patient/info`;
export const GET_AUTOPAY_CARD_DELETE_URL = `${API_BASE_URL}/v1/autopay/card/delete`;
export const GET_AUTOPAY_PATIENT_UPDATE_URL = `${API_BASE_URL}/v1/autopay/patient/update`;

// Payments
export const GET_PAYMENTS_OUTSTANDING_BILLS_ALL_CLUSTERS_URL = `${API_BASE_URL}/v1/bills/outstandingtotal`;
export const GET_PAYMENTS_OUTSTANDING_BILLS_URL = `${API_BASE_URL}/v1/bills/outstanding`;
export const GET_PAYMENTS_PAID_BILLS_HISTORY_URL = `${API_BASE_URL}/v1/bills/history`;
export const GET_PAYMENTS_PAYMENT_INFO_URL = `${API_BASE_URL}/v1/payments/status`;
export const GET_PAYMENTS_DOWNLOAD_BILL_URL = `${API_BASE_URL}/v1/bills/invoicepdf`;
export const GET_PAYMENTS_MANUAL_BILL_URL = `${API_BASE_URL}/v1/bills/manual`;
export const GET_PAYMENTS_DOWNLOAD_RECEIPT_PDF_URL = `${API_BASE_URL}/v1/payments/receipt`;
export const SUBMIT_PAYMENTS_REQUEST_URL = `${API_BASE_URL}/v1/payments/request`;
export const SUBMIT_PAYMENTS_RECEIPT_EMAIL_REQUEST = `${API_BASE_URL}/v1/payments/receiptemail`;

// Payments Public
export const GET_PAYMENTS_PUBLIC_MANUAL_BILL_URL = `${API_BASE_URL}/v1/public/bills/manual`;
export const SUBMIT_PAYMENTS_PUBLIC_REQUEST_URL = `${API_BASE_URL}/v1/public/payments/request`;
export const GET_PAYMENTS_PUBLIC_PAYMENT_INFO_URL = `${API_BASE_URL}/v1/public/payments/status`;
export const GET_PAYMENTS_PUBLIC_DOWNLOAD_RECEIPT_URL = `${API_BASE_URL}/v1/public/payments/receipt`;
export const SEND_PAYMENTS_PUBLIC_RECEIPT_EMAIL_URL = `${API_BASE_URL}/v1/public/payments/receiptemail`;
export const GET_PAYMENTS_BILL_INSTITUTION_URL = `${API_BASE_URL}/v1/public/bills/institutions`;

// Bills
export const GET_OUTSTANDING_BILLS_URL = `${API_BASE_URL}/v1/invoices/outstanding`;
export const GET_OUTSTANDING_BILLS_TOTAL_URL = `${API_BASE_URL}/v1/invoices/outstandingtotal`;
export const GET_INVOICES_HISTORY_URL = `${API_BASE_URL}/v1/invoices/history`;
export const GET_MANUAL_INVOICE_URL = `${API_BASE_URL}/v1/invoices/manual`;
export const GET_PUBLIC_MANUAL_INVOICE_URL = `${API_BASE_URL}/v1/public/invoices/manual`;
export const GET_INVOICE_INSTITUTIONS_URL = `${API_BASE_URL}/v1/public/invoices/institutions`;
export const GET_INVOICE_DOWNLOAD_BILL_URL = `${API_BASE_URL}/v1/invoices/invoicepdf`;
export const GET_INVOICE_PUBLIC_DOWNLOAD_RECEIPT_URL = `${API_BASE_URL}/v1/public/invoices/receipt`;
export const GET_INVOICE_DOWNLOAD_RECEIPT_PDF_URL = `${API_BASE_URL}/v1/invoices/receipt`;
export const SUBMIT_INVOICE_RECEIPT_EMAIL_REQUEST = `${API_BASE_URL}/v1/invoices/receiptemail`;
export const SUBMIT_INVOICE_PUBLIC_RECEIPT_EMAIL_REQUEST = `${API_BASE_URL}/v1/public/invoices/receiptemail`;

// PaymentV2
export const GET_PAYMENT_OPTIONS_URL = `${API_BASE_URL}/v1/payment-service/v2/paymentoptions`;
export const SUBMIT_PAYMENT_SERVICE_REQUEST_URL = `${API_BASE_URL}/v1/payment-service/v2/request`;
export const SUBMIT_PAYMENT_SERVICE_PUBLIC_REQUEST_URL = `${API_BASE_URL}/v1/public/payment-service/v2/request`;
export const GET_PUBLIC_PAYMENT_OPTIONS_URL = `${API_BASE_URL}/v1/public/payment-service/v2/paymentoptions`;
export const GET_PAYMENT_INFO_URL = `${API_BASE_URL}/v1/payment-service/v2/status`;
export const GET_PAYMENT_PUBLIC_INFO_URL = `${API_BASE_URL}/v1/public/payment-service/v2/status`;
export const LIST_PAYMENT_CARDS_URL = `${API_BASE_URL}/v1/payment-service/v2/cards/list`;
export const ADD_PAYMENT_CARD_URL = `${API_BASE_URL}/v1/payment-service/v2/cards/add`;
export const GET_TOKENIZATION_STATUS_URL = `${API_BASE_URL}/v1/payment-service/v2/cards/status`;
export const UPDATE_PAYMENT_CARD_URL = `${API_BASE_URL}/v1/payment-service/v2/cards/update`;
export const DELETE_PAYMENT_CARD_URL = `${API_BASE_URL}/v1/payment-service/v2/cards/delete`;

export const GET_MESSAGE_SETTINGS_URL = `${API_BASE_URL}/v1/public/commons/messagesettings`;

export const UPDATE_LOGIN_URL = `${API_BASE_URL}/v1/profiles/login`;

// Refunds
export const GET_REFUNDS_INSTITUTIONS_URL = `${API_BASE_URL}/v1/refunds/institutions`;
export const GET_REFUNDS_INFO_URL = `${API_BASE_URL}/v1/refunds/info`;
export const GET_REFUNDS_VERIFY_URL = `${API_BASE_URL}/v1/refunds/verify`;
export const GET_REFUNDS_BANKS_URL = `${API_BASE_URL}/v1/refunds/banks`;
export const SUBMIT_REFUNDS_URL = `${API_BASE_URL}/v1/refunds/submit`;

// Questionnaire
export const GET_ONBOARDING_QUESTIONNAIRE_URL = `${API_BASE_URL}/v1/hsg/qns/questions`;
export const SAVE_ONBOARDING_QUESTIONNAIRE_ANSWERS_URL = `${API_BASE_URL}/v1/hsg/qns/submit`;
export const GET_ONBOARDING_QUESTION_ANSWERS_URL = `${API_BASE_URL}/v1/hsg/qns/responselist`;

// Prescription
export const GET_PRESCRIPTION_RESULT = `${API_BASE_URL}/v1/healthrecords/prescriptionsummary`;
export const GET_PRESCRIPTION_PDF = `${API_BASE_URL}/v1/healthrecords/prescriptionpdf`;

// Nehr Access History
export const GET_NEHR_ACCESS_HISTORY_RESULT = `${API_BASE_URL}/v1/healthrecords/nehraccesshistory`;
export const GET_NEHR_ACCESS_HISTORY_PDF = `${API_BASE_URL}/v1/healthrecords/nehraccesshistorypdf`;
export const GET_PUBLIC_HEALTHCARE_CLUSTERS = `${API_BASE_URL}/v1/healthrecords/publichealthcareclusters`;

// Nehr Access Restriction
export const GET_ACCESS_RESTRICTION = `${API_BASE_URL}/v1/healthrecords/getaccessrestriction`;
export const UPDATE_ACCESS_RESTRICTION = `${API_BASE_URL}/v1/healthrecords/updateaccessrestriction`;
export const GET_INSTITUTIONS = `${API_BASE_URL}/v1/healthrecords/accessrestrictioninstitutions`;

export const PAYMENTS_CONSENT_FAQ_URL = `${PUBLIC_FAQ_URL}/hc/en-us/categories/15435095166489-Caregiver-and-Care-Recipient-Access`;
export const MEDICATIONS_FAQ_URL = `${PUBLIC_FAQ_URL}/hc/en-us/categories/15434973132057-Medications`;
export const CARE_RECIPIENT_FAQ_URL = `${PUBLIC_FAQ_URL}/hc/en-us/articles/15756003474201-How-do-I-get-access-to-the-health-records-of-my-care-recipient-What-can-I-do-on-HealthHub-on-behalf-of-my-care-recipient`;
export const NATIONAL_IMMUNISATION_REGISTRY_WEBSITE = `https://www.nir.hpb.gov.sg/nird/ens/enslogin`;
export const ACCESS_FAQ_URL = `https://support.healthhub.sg/hc/en-us/categories/15435095166489-Caregiver-Access`;

// Immunisation URL
export const GET_SCHEDULED_IMMUNISATION = `${API_BASE_URL}/v1/healthrecords/immunisationscheduled`;

export const GET_SUMMARY_IMMUNISATION = `${API_BASE_URL}/v1/healthrecords/immunisationsummary`;

export const GET_MORE_ABOUT_INFORMATION = `${API_BASE_URL}/v1/healthrecords/immunisationinfomessage`;

export const GET_YOUR_IMMUNISATION_RECORDS_URL = `${API_BASE_URL}/v1/healthrecords/immunisationcompletedadult`;

export const GET_VACCINATION_HISTORY_PDF = `${API_BASE_URL}/v1/healthrecords/immunisationcompletedpdf`;

export const GET_DISCHARGE_SUMMARY = `${API_BASE_URL}/v1/healthrecords/dischargesummary`;
export const GET_DISCHARGE_DETAILS = `${API_BASE_URL}/v1/healthrecords/dischargedetails`;
export const GET_DISCHARGE_DETAILS_PDF = `${API_BASE_URL}/v1/healthrecords/dischargepdf`;

// Radiology URL
export const GET_RADIOLOGY_SUMMARY = `${API_BASE_URL}/v1/healthrecords/radiologysummary`;
export const GET_RADIOLOGY_REPORTS_PDF = `${API_BASE_URL}/v1/healthrecords/radiologypdf`;

// Health Screening
export const GET_HEALTH_SCREENING_SUMMARY = `${API_BASE_URL}/v1/healthassessment/healthscr/summary`;
export const GET_HEALTH_SCREENING_DETAILS = `${API_BASE_URL}/v1/healthassessment/healthscr/details`;
export const GET_HEALTH_SCREENING_ELIGIBILE = `${API_BASE_URL}/v1/healthassessment/eligiblescreening`;
// Caregivers
export const GET_CAREGIVER_DETAILS = `${API_BASE_URL}/v1/secure/caregivers/detail`;
export const GET_CAREGIVERS_HEALTH_RECORDS_TYPES = `${API_BASE_URL}/v1/secure/caregivers/healthrecords`;
export const VERIFY_CAREGIVER_NRIC = `${API_BASE_URL}/v1/secure/caregivers/verify`;
export const UPDATE_CAREGIVER_STATUS = `${API_BASE_URL}/v1/secure/caregivers/status`;
export const ADD_CAREGIVER = `${API_BASE_URL}/v1/secure/caregivers/add`;
export const UPDATE_CAREGIVER = `${API_BASE_URL}/v1/secure/caregivers/update`;
export const VERIFY_CAREGIVER_REQUEST = `${API_BASE_URL}/v1/secure/carerecipients/verify`;
export const UPDATE_CAREGIVER_CONSENT_URL = `${API_BASE_URL}/v1/secure/caregivers/consent`;

// Children's Health
export const ADD_RELATED_PERSON = `${API_BASE_URL}/v1/secure/carerecipients/add`;
export const GET_RELATED_PEOPLE = `${API_BASE_URL}/v1/profiles/relatedpeople`;
export const GET_RELATED_PERSON_DETAILS = `${API_BASE_URL}/v1/secure/carerecipients/details`;
export const UPDATE_RELATED_PERSON = `${API_BASE_URL}/v1/secure/carerecipients/update`;
export const UPDATE_RELATED_PERSON_STATUS = `${API_BASE_URL}/v1/secure/carerecipients/status`;

// Birth Information
export const GET_BIRTH_INFORMATION = `${API_BASE_URL}/v1/childrenhealth/birthinfo/details`;
export const SAVE_BIRTH_INFORMATION = `${API_BASE_URL}/v1/childrenhealth/birthinfo/save`;
export const DELETE_BIRTH_INFORMATION = `${API_BASE_URL}/v1/childrenhealth/birthinfo/remove`;

// Growth Chart
export const GET_GROWTH_CHART_SUMMARY = `${API_BASE_URL}/v1/childrenhealth/growthchart/summary`;
export const GET_GROWTH_CHART_LATEST = `${API_BASE_URL}/v1/childrenhealth/growthchart/latest`;
export const GET_GROWTH_CHART_POINTS = `${API_BASE_URL}/v1/childrenhealth/growthchart/points`;
export const SAVE_GROWTH_CHART_ENTRY = `${API_BASE_URL}/v1/childrenhealth/growthchart/save`;
export const DELETE_GROWTH_CHART_ENTRY = `${API_BASE_URL}/v1/childrenhealth/growthchart/remove`;
export const GET_GROWTH_CHART_CONTENT = `${API_BASE_URL}/v1/childrenhealth/growthchart/content`;
export const GET_GROWTH_CHART_DETAILS = `${API_BASE_URL}/v1/childrenhealth/growthchart/details`;
export const GET_PROFILES_DETAILS = `${API_BASE_URL}/v1/profiles/details`;

// School Dental Records
export const GET_SCHOOL_DENTAL_RECORDS = `${API_BASE_URL}/v1/schoolhealth/oralhealth`;

// School Health Assessment Summary
export const GET_SCHOOL_HEALTH_ASSESSMENT_SUMMARY_URL = `${API_BASE_URL}/v1/healthassessment/summary`;

export const CHECK_PERMISSION_URL = `${API_BASE_URL}/v1/secure/caregivers/validaterequester`;

export const GET_SCHOOL_HEALTH_PDF = `${API_BASE_URL}/v1/schoolhealth/pdf`;

// Personal Health
export const GET_FEDERATED_USER_PROFILE_URL = `${API_BASE_URL}/v1/profiles/federateduser`;
export const GET_USER_PROFILE_BASIC_URL = `${API_BASE_URL}/v1/profiles/basic`;
export const GET_USER_PROFILE_PATIENT_MASTER_URL = `${API_BASE_URL}/v1/profiles/patientmaster`;
export const GET_USER_PROFILE_BASIC_SECURE_URL = `${API_BASE_URL}/v1/secure/profiles/basic`;
export const GET_USER_PROFILE_PATIENT_MASTER_SECURE_URL = `${API_BASE_URL}/v1/secure/profiles/patientmaster`;
export const UPDATE_USER_PROFILE_BASIC_URL = `${API_BASE_URL}/v1/secure/profiles/basic/update`;
export const UPDATE_USER_PROFILE_PATIENT_MASTER_URL = `${API_BASE_URL}/v1/secure/profiles/patientmaster/update`;
export const CREATE_USER_PROFILE_PATIENT_MASTER_URL = `${API_BASE_URL}/v1/secure/profiles/patientmaster/create`;

export const GET_MYINFO_URL = `${API_BASE_URL}/v1/secure/profiles/myinfourl`;
export const GET_RETRIEVE_MYINFO_URL = `${API_BASE_URL}/v1/secure/profiles/retrievemyinfo`;

// New Appointments
export const GET_APPOINTMENTS_URL = `${API_BASE_URL}/v1/appointments/list`;
export const GET_SLOT_SEARCH_DATES_URL = `${API_BASE_URL}/v1/appointments/slots/dates`;
export const GET_SLOT_AVAILABILITY_URL = `${API_BASE_URL}/v1/appointments/slots/availability`;
export const GET_APPOINTMENT_SLOTS_URL = `${API_BASE_URL}/v1/appointments/slots`;
export const APPOINTMENT_RESCHEDULING_URL = `${API_BASE_URL}/v1/appointments/reschedule`;
export const APPOINTMENT_RESCHEDULING_LINKED_URL = `${API_BASE_URL}/v1/appointments/reschedulelinked`;
export const APPOINTMENT_BOOKING_URL = `${API_BASE_URL}/v1/appointments/book`;
export const APPOINTMENT_CANCELING_URL = `${API_BASE_URL}/v1/appointments/cancel`;
export const GET_APPOINTMENT_INSTITUTIONS_URL = `${API_BASE_URL}/v1/appointments/institutions`;
export const GET_APPOINTMENT_PUBLIC_INSTITUTIONS_URL = `${API_BASE_URL}/v1/public/appointments/institutions`;
export const SERVICE_TYPES_APPOINTMENT_URL = `${API_BASE_URL}/v1/appointments/services`;
export const DOCTORS_APPOINTMENT_URL = `${API_BASE_URL}/v1/appointments/practitioners`;
export const GET_TCU_AVAILABLE_DATE_APPOINTMENT_URL = `${API_BASE_URL}/v1/appointments/tcu/slots/dates`;
export const GET_TCU_AVAILABLE_SLOT_APPOINTMENT_URL = `${API_BASE_URL}/v1/appointments/tcu/slots`;
export const GET_APPOINTMENT_TCU_REQUEST_ID_URL = `${API_BASE_URL}/v1/appointments/tcu/requestid`;
export const CREATE_TCU_APPOINTMENT_URL = `${API_BASE_URL}/v1/appointments/tcu/book`;
export const GET_QUESTIONNAIRE_URL = `${API_BASE_URL}/v1/appointments/questionnaires/details`;
export const GET_APPOINTMENT_FORM_TEMPLATE_URL = `${API_BASE_URL}/v1/appointments/form`;
export const QUESTIONNAIRE_SUBMISSION_URL = `${API_BASE_URL}/v1/appointments/questionnaires/submit`;
export const QUESTIONNAIRE_SAVING_URL = `${API_BASE_URL}/v1/appointments/questionnaires/save`;
export const APPOINTMENT_FORM_SUBMISSION_URL = `${API_BASE_URL}/v1/appointments/form/submit`;
export const APPOINTMENT_PUBLIC_FORM_SUBMISSION_URL = `${API_BASE_URL}/v1/public/appointments/form/submit`;
export const GET_TODAY_APPOINTMENTS_URL = `${API_BASE_URL}/v1/mobilereg/todayappt`;
export const APPOINTMENT_GET_SYSTEM_PARAMS_URL = `${API_BASE_URL}/v1/appointments/systemparams`;
export const PREFERRED_LOCATIONS_URL = `${API_BASE_URL}/v1/commons/preferredlocations`;
export const UPDATE_PREFERRED_LOCATIONS_URL = `${API_BASE_URL}/v1/commons/preferredlocations/update`;
export const GET_APPOINTMENTS_VCP_DETAILS_URL = `${API_BASE_URL}/v1/appointments/vcp/details`;
export const GET_APPOINTMENT_PATIENT_INFORMATION_URL = `${API_BASE_URL}/v1/appointments/patient/info`;
export const UPDATE_APPOINTMENT_PATIENT_INFORMATION_URL = `${API_BASE_URL}/v1/appointments/patient/info/update`;
export const GET_APPOINTMENT_PATIENT_SOURCES_URL = `${API_BASE_URL}/v1/appointments/patient/sources`;
export const CREATE_APPOINTMENT_NEW_PATIENT_URL = `${API_BASE_URL}/v1/appointments/patient`;
export const GET_APPOINTMENT_VISITOR_QUOTA_URL = `${API_BASE_URL}/v1/appointments/visitor/quota`;
export const FIND_APPOINTMENT_VISITORS_URL = `${API_BASE_URL}/v1/appointments/visitor/find`;
export const GET_APPOINTMENT_KIOSK_QUESTIONNAIRE_URL = `${API_BASE_URL}/v1/appointments/visitor/kiosk`;
export const ADD_APPOINTMENT_VISITOR_URL = `${API_BASE_URL}/v1/appointments/visitor/add`;
export const GET_APPOINTMENT_UPCOMING_URL = `${API_BASE_URL}/v1/appointments/upcoming`;
export const GET_VALIDATE_VACCINATION_APPOINTMENT_URL = `${API_BASE_URL}/v1/appointments/hsg/validate/vaccination`;
export const GET_HSG_VALIDATE_ENROLLMENT_APPOINTMENT_URL = `${API_BASE_URL}/v1/appointments/hsg/validate/enrollment`;
export const GET_HSG_VALIDATE_SERVICE_APPOINTMENT_URL = `${API_BASE_URL}/v1/appointments/hsg/validate/service`;
export const GET_HSG_VALIDATE_MAMMOGRAM_APPOINTMENT_URL = `${API_BASE_URL}/v1/appointments/hsg/validate/mammogram`;
export const GET_HAS_PATIENT_INFO_URL = `${API_BASE_URL}/v1/appointments/hsg/has/patientprofile`;
export const SUBMIT_EMAIL_HSG_APPOINTMENT_URL = `${API_BASE_URL}/v1/appointments/hsg/submitform`;
export const GET_OTP_URL = `${API_BASE_URL}/v1/appointments/hsg/otp/get`;
export const VALIDATE_OTP_URL = `${API_BASE_URL}/v1/appointments/hsg/otp/validate`;
export const GET_HSG_SERVICE_ID = `${API_BASE_URL}/v1/appointments/hsg/serviceid`;
export const GET_PCP_INFO = `${API_BASE_URL}/v1/appointments/hsg/pcpinfo`;
export const GET_HSG_UPCOMING_APPOINTMENT = `${API_BASE_URL}/v1/appointments/hsg/upcoming`;
export const GET_LIVE_CHAT_URL = `${API_BASE_URL}/v1/commons/nuhs/livechat`;
export const GET_EISS_DATE = `${API_BASE_URL}/v1/appointments/hsg/eissdate`;

// Mobile Reg
export const MOBILEREG_KIOSK_QUESTIONNAIRE = `${API_BASE_URL}/v1/mobilereg/questionnaires/kiosk`;
export const MOBILEREG_ACTUALISE = `${API_BASE_URL}/v1/mobilereg/actualise`;
export const MOBILEREG_QUEUE_JOURNEY = `${API_BASE_URL}/v1/mobilereg/queuejourney`;
export const MOBILEREG_CONTACT_NUMBER = `${API_BASE_URL}/v1/mobilereg/contactnumber`;
export const MOBILEREG_CHECKIN = `${API_BASE_URL}/v1/mobilereg/checkin`;

// Upload photo
export const UPLOAD_S3_FILE_URL = `${API_BASE_URL}/v1/secure/profiles/presignedurl`;
export const GET_S3_FILE_URL = `${API_BASE_URL}/v1/secure/file/get`;
export const UPLOAD_PROFILE_PHOTO_URL = `${API_BASE_URL}/v1/secure/profiles/uploadphoto`;

// Services Links
export const GET_SERVICES_LINKS_URL = `${API_BASE_URL}/v1/homepage/servicelinks`;
export const GET_PUBLIC_SERVICES_LINKS_URL = `${API_BASE_URL}/v1/public/homepage/servicelinks`;

export const GET_PUBLIC_SERVICE_CATALOG_URL = `${API_BASE_URL}/v1/public/commons/servicecatalog`;
export const GET_SERVICE_CATALOG_URL = `${API_BASE_URL}/v1/commons/servicecatalog`;

export const GET_MILESTONES_INFO_URL = `${API_BASE_URL}/v1/childrenhealth/milestone/info`;
export const GET_MILESTONES_SUMMARY_URL = `${API_BASE_URL}/v1/childrenhealth/milestone/summary`;
export const GET_MILESTONES_TODO_LIST_URL = `${API_BASE_URL}/v1/childrenhealth/milestone/todolist`;
export const GET_MILESTONES_BY_YEAR_URL = `${API_BASE_URL}/v1/childrenhealth/milestone/byyear`;
export const GET_MILESTONES_BY_TYPE_URL = `${API_BASE_URL}/v1/childrenhealth/milestone/bytype`;
export const GET_MILESTONES_CONTENT_URL = `${API_BASE_URL}/v1/childrenhealth/milestone/content`;
export const GET_MILESTONES_DETAILS_URL = `${API_BASE_URL}/v1/childrenhealth/milestone/details`;
export const SAVE_MILESTONE_STATUS_URL = `${API_BASE_URL}/v1/childrenhealth/milestone/save`;
export const GET_ARCHIVED_MILESTONES_URL = `${API_BASE_URL}/v1/childrenhealth/milestone/archived`;

// Health Risk Assessment
export const GET_HRA_SUMMARY = `${API_BASE_URL}/v1/healthassessment/dra`;
export const SUBMIT_DRA = `${API_BASE_URL}/v1/healthassessment/submitdra`;

// Emergency Care/Department
export const GET_HDF_QUESTIONNAIRE_URL = `${API_BASE_URL}/v1/emergencycare/questionnaire`;
export const GET_EMERGENCY_FORM_BY_ID_URL = `${API_BASE_URL}/v1/emergencycare/formresponse/details`;
export const SUBMIT_EMERGENCY_FORM_URL = `${API_BASE_URL}/v1/emergencycare/formresponse/submit`;
export const GET_ED_WAIT_TIME_URL = `${API_BASE_URL}/v1/emergencycare/waitingtime`;
export const GET_ED_RETRIEVE_MY_CHART_OMW_DETAILS_URL = `${API_BASE_URL}/v1/emergencycare/mychartomwinfo/details`;
export const SAVE_ED_RETRIEVE_MY_CHART_OMW_INFO_URL = `${API_BASE_URL}/v1/emergencycare/mychartomwinfo/save`;

// Medrefill
export const GET_MEDREFILL_INSTITUTIONS_URL = `${API_BASE_URL}/v1/medrefill/institutions`;
export const GET_MEDREFILL_PAYMENT_MODES_URL = `${API_BASE_URL}/v1/medrefill/payments/list`;
export const GET_MEDREFILL_MEDICATIONS_LIST_URL = `${API_BASE_URL}/v1/medrefill/medications/list`;
export const GET_MEDREFILL_COLLECTIONS_LIST_URL = `${API_BASE_URL}/v1/medrefill/collections/list`;
export const GET_MEDREFILL_LOCATIONS_LIST_URL = `${API_BASE_URL}/v1/medrefill/locations/list`;
export const GET_MEDREFILL_PUBLIC_HOLIDAYS_URL = `${API_BASE_URL}/v1/public/medrefill/publicholidays`;
export const GET_MEDREFILL_CLINIC_LIST_URL = `${API_BASE_URL}/v1/medrefill/clinics`;
export const GET_MEDREFILL_PRESCRIPTIONS_DETAILS_URL = `${API_BASE_URL}/v1/medrefill/prescriptions/details`;
export const SUBMIT_MEDREFILL_REQUEST_URL = `${API_BASE_URL}/v1/medrefill/transactions/submit`;
export const GET_MEDREFILL_PRESCRIPTIONS_LIST_URL = `${API_BASE_URL}/v1/medrefill/prescriptions/list`;

// Medrefill Public
export const GET_PUBLIC_MEDREFILL_INSTITUTIONS_URL = `${API_BASE_URL}/v1/public/medrefill/institutions`;
export const GET_PUBLIC_MEDREFILL_PAYMENT_MODES_URL = `${API_BASE_URL}/v1/public/medrefill/payments/list`;
export const GET_PUBLIC_MEDREFILL_MEDICATIONS_LIST_URL = `${API_BASE_URL}/v1/public/medrefill/medications/list`;
export const GET_PUBLIC_MEDREFILL_COLLECTIONS_LIST_URL = `${API_BASE_URL}/v1/public/medrefill/collections/list`;
export const GET_PUBLIC_MEDREFILL_LOCATIONS_LIST_URL = `${API_BASE_URL}/v1/public/medrefill/locations/list`;
export const GET_PUBLIC_MEDREFILL_CLINIC_LIST_URL = `${API_BASE_URL}/v1/public/medrefill/clinics`;
export const SUBMIT_PUBLIC_MEDREFILL_REQUEST_URL = `${API_BASE_URL}/v1/public/medrefill/transactions/submit`;

// Pharmacy Queue
export const GET_PHARMACY_QUEUE_INSTITUTIONS_URL = `${API_BASE_URL}/v1/pharmacyqueue/institutions`;
export const REGISTER_PHARMACY_QUEUE_URL = `${API_BASE_URL}/v1/pharmacyqueue/register`;
export const GET_PHARMACY_QUEUE_JOURNEY_URL = `${API_BASE_URL}/v1/pharmacyqueue/queuejourney`;
export const GET_PHARMACY_QUEUE_PHARMACIES_URL = `${API_BASE_URL}/v1/pharmacyqueue/pharmacies`;

// MedRefill History
export const GET_MEDREFILL_TRANSACTION_LIST_URL = `${API_BASE_URL}/v1/medrefill/transactions/list`;
export const GET_MEDREFILL_TRANSACTION_DETAILS_URL = `${API_BASE_URL}/v1/medrefill/transactions/details`;
export const SUBMIT_MEDREFILL_TRANSACTION_CANCEL_REQUEST_URL = `${API_BASE_URL}/v1/medrefill/transactions/cancel`;

// MRRP
export const GET_MRRP_INSTITUTIONS = `${API_BASE_URL}/v1/mrrp/institutions`;
export const GET_MRRP_TNC_URL = `${API_BASE_URL}/v1/mrrp/termsandconditions`;
export const GET_MRRP_REPORT_TYPE_URL = `${API_BASE_URL}/v1/mrrp/reporttypes`;
export const GET_MRRP_VALIDATE_SUBJECT_URL = `${API_BASE_URL}/v1/mrrp/validatesubject`;
export const GET_MRRP_VISIT_TYPE_URL = `${API_BASE_URL}/v1/mrrp/typeofvisit`;
export const GET_MRRP_DEPARTMENT_URL = `${API_BASE_URL}/v1/mrrp/departments`;
export const GET_MRRP_PURPOSE_URL = `${API_BASE_URL}/v1/mrrp/purpose`;
export const GET_MRRP_PATIENT_RELATIONSHIP_URL = `${API_BASE_URL}/v1/mrrp/patientrelationship`;
export const GET_MRRP_MODE_OF_DELIVERY_URL = `${API_BASE_URL}/v1/mrrp/modeofdelivery`;
export const SUBMIT_MRRP_REPORT_URL = `${API_BASE_URL}/v1/mrrp/createreport`;
export const SUBMIT_MRRP_PAYMENT_URL = `${API_BASE_URL}/v1/mrrp/payment`;
export const GET_MRRP_PAYMENT_INFO_URL = `${API_BASE_URL}/v1/mrrp/paymentinfo`;
export const GET_MRRP_HISTORY_URL = `${API_BASE_URL}/v1/mrrp/history`;
export const GET_MRRP_REPORT_PDF_URL = `${API_BASE_URL}/v1/mrrp/medicalreportpdf`;

// Children Health Notification
export const GET_CHILDREN_HEALTH_NOTIFICATIONS = `${API_BASE_URL}/v1/notifications/childrenhealth`;
export const GET_CHILDREN_HEALTH_AGE_CONTENT = `${API_BASE_URL}/v1/childrenhealth/agecontent`;
export const GET_NOTIFICATIONS = `${API_BASE_URL}/v1/notifications`;

// Financial Consent
export const GET_FINANCIAL_CONSENT_SUMMARY_URL = `${API_BASE_URL}/v1/secure/financials/summary`;
export const GET_FINANCIAL_CONSENT_DETAILS_URL = `${API_BASE_URL}/v1/secure/financials/details`;
export const SUBMIT_FINANCIAL_CONSENT_MCAF_URL = `${API_BASE_URL}/v1/secure/financials/submitmcaf`;
export const SUBMIT_FINANCIAL_CONSENT_NEFR_URL = `${API_BASE_URL}/v1/secure/financials/submitnefr`;

// CHAS
export const GET_CHAS_BALANCE_URL = `${API_BASE_URL}/v1/financials/chasbalance`;
export const GET_CHAS_CLAIMS_URL = `${API_BASE_URL}/v1/financials/chasclaims`;
export const GET_CHAS_SUMMARY_URL = `${API_BASE_URL}/v1/financials/chassummary`;

// Preferred Language
export const UPDATE_PREFERRED_LANGUAGE_URL = `${API_BASE_URL}/v1/homepage/preferredlanguage/update`;
export const GET_PREFERRED_LANGUAGE_URL = `${API_BASE_URL}/v1/homepage/preferredlanguage`;

// Test Reports
export const GET_TEST_REPORTS_SUMMARY_URL = `${API_BASE_URL}/v1/healthrecords/testreportsummary`;
export const GET_TEST_REPORTS_PDF_URL = `${API_BASE_URL}/v1/healthrecords/testreportpdf`;

// Derom
export const GET_DEROM_VACCINATION_STATUS_URL = `${API_BASE_URL}/v1/healthrecords/deromvaccinationstatus`;
export const GET_DEROM_TEST_RESULT_URL = `${API_BASE_URL}/v1/healthrecords/deromtestresults`;
export const GET_DEROM_DISEASE_SUMMARY_URL = `${API_BASE_URL}/v1/healthrecords/deromdiseasesummary`;
export const GET_DEROM_VACCINATION_COMPLETED_URL = `${API_BASE_URL}/v1/healthrecords/deromvaccinationcompleted`;

// Important Notices
export const GET_IMPORTANT_NOTICES_URL = `${API_BASE_URL}/v1/public/commons/imptnotices`;

// Sitecore
export const GET_HOME_PAGE_TRENDING_ARTICLES_URL = `${sitecoreHomeBaseUrl()}/sitecore/api/ssc/healthhub/homepagetrendingarticles`;
export const CREATE_SUBSCRIPTION_NEWSLETTER_URL = `${sitecoreHomeBaseUrl()}/api/sitecore/newslettersignup/createsubscription`;
export const GET_ARTICLES_BY_TEXT_URL = `${sitecoreHomeBaseUrl()}/api/eservicessearch/results`;
export const GET_MOBILE_APP_BANNER_URL = `${sitecoreHomeBaseUrl()}/sitecore/api/ssc/healthhub/mobileappbanner`;

// Inbox
export const GET_PUBLIC_INBOX_MESSAGES_URL = `${API_BASE_URL}/v1/public/inbox/messages`;
export const GET_INBOX_MESSAGES_URL = `${API_BASE_URL}/v1/inbox/messages`;
export const GET_INBOX_MESSAGES_UNREAD_COUNT_URL = `${API_BASE_URL}/v1/inbox/unreadmessagecount`;
export const DELETE_INBOX_MESSAGE_URL = `${API_BASE_URL}/v1/inbox/delete`;
export const UPDATE_INBOX_READ_FLAG_URL = `${API_BASE_URL}/v1/inbox/updatereadflag`;
export const PIN_INBOX_MESSAGE_URL = `${API_BASE_URL}/v1/inbox/pin`;

// Activities and Events
export const GET_ACTIVITIES_EVENTS_LIST_URL = `${API_BASE_URL}/v1/events/list`;
export const GET_ACTIVITY_EVENT_DETAILS_URL = `${API_BASE_URL}/v1/events/details`;
export const GET_ACTIVITY_EVENT_FILTERS_URL = `${API_BASE_URL}/v1/events/filters`;
export const GET_ACTIVITY_EVENTS_SESSIONS_URL = `${API_BASE_URL}/v1/events/sessions`;
export const GET_BOOKED_ACTIVITIES_EVENTS_URL = `${API_BASE_URL}/v1/events/bookings`;
export const UPDATE_ACTIVITY_EVENT_ATTENDANCE_URL = `${API_BASE_URL}/v1/events/attendance`;
export const REGISTER_ACTIVITY_EVENT_URL = `${API_BASE_URL}/v1/events/register`;
export const CANCEL_ACTIVITY_EVENT_URL = `${API_BASE_URL}/v1/events/cancel`;
export const GET_PATIENT_INFO_URL = `${API_BASE_URL}/v1/events/patientinfo`;

// One Map
export const GET_POSTAL_ADDRESS_URL = `${API_BASE_URL}/v1/commons/getpostaladdress`;
export const GET_PUBLIC_POSTAL_ADDRESS_URL = `${API_BASE_URL}/v1/public/commons/getpostaladdress`;

export const HEALTHHUB_TIKTOK_URL = 'https://www.tiktok.com/@healthhub.sg';
export const HEALTHHUB_TELEGRAM_URL = 'https://t.me/HealthHubSG';

// Admission
export const GET_ADMISSION_LIST = `${API_BASE_URL}/v1/admissions/list`;
export const ADMISSION_ACKNOWLEDGE_FINANCIAL_COUNSELLING = `${API_BASE_URL}/v1/admissions/acknowledge`;
export const GET_ADMISSION_DETAILS = `${API_BASE_URL}/v1/admissions/get`;
export const GET_ADMISSION_DOWNLOAD_TERMS = `${API_BASE_URL}/v1/admissions/terms/download`;
export const GET_WARDS = `${API_BASE_URL}/v1/admissions/wards/list`;
export const REQUEST_CHANGE_WARD = `${API_BASE_URL}/v1/admissions/wards/update`;
export const SUBMIT_PAYMENT = `${API_BASE_URL}/v1/admissions/payments/submit`;
export const GET_PAYMENT_INFO = `${API_BASE_URL}/v1/admissions/payments/get`;

// maintenance
export const GET_MODULES_MAINTENANCE_URL = `${API_BASE_URL}/v1/public/commons/maintenance`;

// term of use
export const GET_TERMS_OF_USE_URL = `${API_BASE_URL}/v1/profiles/userconsent`;
export const UPDATE_TERMS_OF_USE_URL = `${API_BASE_URL}/v1/profiles/userconsent/update`;

// User Preferences
export const GET_USER_PREFERENCE_URL = `${API_BASE_URL}/v1/commons/userpreferences`;
export const UPDATE_USER_PREFERENCE_URL = `${API_BASE_URL}/v1/commons/userpreferences/update`;
